import { urlService, seoName } from 'core-utilities';
import { entityUrl } from 'core-roblox-utilities';
import { v4 as uuidv4 } from 'uuid';

export const buildGameDetailUrl = (
  placeId: number,
  placeName: string,
  params: Record<string, string | number> = {}
): string => {
  const parsedParams = Object.keys(params).reduce<Record<string, string | number>>((acc, data) => {
    acc[data.charAt(0).toUpperCase() + data.slice(1)] = params[data];
    return acc;
  }, {});
  const gameDetailUrl = urlService.getUrlWithQueries(
    `${entityUrl.game.getRelativePath(placeId)}/${seoName.formatSeoName(placeName)}`,
    parsedParams
  );
  return gameDetailUrl;
};

export const getSession = (sessionName: string): string => {
  const queries = urlService.parseQueryString(window.location.search.toLowerCase());
  if (!queries[sessionName]) {
    queries[sessionName] = uuidv4();
    window.history.replaceState(null, '', urlService.getUrlWithQueries('', queries));
  }
  return queries[sessionName] as string;
};

export default {
  buildGameDetailUrl,
  getSession
};
